// Import Packages
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Box, Select, MenuItem, FormControl } from '@material-ui/core';

// Import pages
import { TextInput } from '../TextInput/NewTextInput';

// Import CSS
import '../CredentialPicker/CredentialPicker.css';

function TabPanel({ children, value, index }) {
    return (<div>{value === index && (<Box>{children}</Box>)}</div>);
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function CustomTab({ action, inputName, options, variables, setOpenVariable, variableRender, setField, type, displayName, onChange, isRequired, optionFetchError }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION.';
    const [value, setValue] = useState('');
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (action.fields) {
            if (!action.fields[inputName]) {
                const defaultOption = options.find(x => x.default);
                action.fields[inputName] = { type, isRequired: isRequired, value: defaultOption ? defaultOption.value : '', tab: 0 };
            } else if (action.fields[inputName]?.tab !== undefined) {
                setTab(action.fields[inputName].tab);
            } else {
                const defaultOption = options.find(x => x.default);
                if (defaultOption) {
                    action.fields[inputName].value = defaultOption.value;
                }
                action.fields[inputName].tab = 0;
                setTab(0);
            }
            setValue(action.fields[inputName].value)
        } else if (action[inputName]) {
            if (action[inputName].tab === undefined) {
                const defaultOption = options.find(x => x.default);
                if (defaultOption) {
                    action[inputName].value = defaultOption.value;
                }
                action[inputName].tab = 0;
                setTab(0);
            } else {
                setTab(action[inputName].tab);
            }
            setValue(action[inputName].value)
        } else {
            action[inputName] = { type, isRequired: isRequired, value: '', tab: 0 }
        }
        if (optionFetchError) {
            setTab(1);
        }
    }, [])

    const ChangeTab = (newTab) => {
        // if you select the tab, the value will be assigned if it is inside
        if (newTab === 0) {
            if (action.fields) {
                if (options.find(x => x.value === action.fields[inputName].value)) {
                    setValue(action.fields[inputName].value);
                } else {
                    action.fields[inputName].value = '';
                    setValue('');
                }
            } else if (action[inputName]) {
                if (options.find(x => x.value === action[inputName].value)) {
                    setValue(action[inputName].value);
                } else {
                    action[inputName].value = '';
                    setValue('');
                }
            }
        }
        // change new tab
        setTab(newTab);
        if (action.fields && action.fields[inputName]) {
            action.fields[inputName].tab = newTab;
        } else if (action[inputName]) {
            action[inputName].tab = newTab;
        }
    };

    const changeSelection = (e) => {
        setValue(e.target.value);
        onChange(e.target.value);
    }

    return (
        <div>
            <div className="condition-tabs">
                <button
                    disabled={optionFetchError ? true : false}
                    className={tab === 0 ? 'condition-active' : ''}
                    onClick={() => ChangeTab(0)}>
                    {t(label + "SELECT")}
                </button>
                <button
                    className={tab === 1 ? 'condition-active' : ''}
                    onClick={() => ChangeTab(1)}>
                    {t(label + "TEXT")}
                </button>
            </div>

            <TabPanel value={tab} index={0} >
                {
                    isRequired && !value && <small style={{ color: '#D75E5E' }}>&nbsp; {t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>
                }

                <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                >
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        style={{
                            backgroundColor: "#fff",
                            height: "40px",
                            fontSize: "12px",
                        }}
                        value={value}
                        id="demo-simple-select-outlined"
                        displayEmpty
                        onChange={changeSelection}
                    >
                        {
                            options.map((cred) => (
                                <MenuItem
                                    style={{ fontSize: 12 }}
                                    value={cred.value}
                                >
                                    {cred.display_name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </TabPanel>
            <TabPanel value={tab} index={1} >
                <TextInput
                    inputName={inputName}
                    action={action}
                    setField={setField}
                    variableRender={variableRender}
                    variables={variables}
                    include={[type]}
                    multiline={type === "object"}
                    setOpenVariable={setOpenVariable}
                    isRequired={isRequired}
                    fieldType={type}
                    displayName={displayName}
                />
            </TabPanel>
        </div>
    );
}

export default CustomTab
